import CryptoJS from 'crypto-js';

class AESUtils {
  constructor(secretKey, iv) {
    this.ivLength = 16;
    this.algorithm = 'AES-256-CBC';
    this.secretKey = CryptoJS.enc.Hex.parse(secretKey); // 32-byte hex key
    this.iv = CryptoJS.enc.Hex.parse(iv); // 16-byte hex IV
  }

  encrypt(dataToEncrypt) {
    const cipher = CryptoJS.AES.encrypt(dataToEncrypt, this.secretKey, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return `${this.iv.toString(CryptoJS.enc.Hex)}:${cipher.toString()}`;
  }

  decrypt(encryptedData) {
    const [ivHex, encryptedText] = encryptedData.split(':');
    const iv = CryptoJS.enc.Hex.parse(ivHex);

    const decrypted = CryptoJS.AES.decrypt(
      {
        ciphertext: CryptoJS.enc.Base64.parse(encryptedText),
      },
      this.secretKey,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      },
    );

    return decrypted.toString(CryptoJS.enc.Utf8).trim();
  }
}

const generateHashKey = (key) => {
  return CryptoJS.SHA256(key).toString(CryptoJS.enc.Hex);
};

const base64Encrypt = (dataToEncrypt) => {
  const ciphertext = CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(dataToEncrypt),
  );

  return ciphertext;
};

const base64Decrypt = (encryptedData) => {
  const bytes = CryptoJS.enc.Base64.parse(encryptedData);

  return bytes.toString(CryptoJS.enc.Utf8).trim();
};

export { AESUtils, generateHashKey, base64Encrypt, base64Decrypt };
